import { useSelector } from "react-redux";
import { PAGE_PERMISSIONS_MAPPINGS } from "../helpers/constants";
import { isEmpty } from "../helpers/utils";
import { userRolesPermissionsSelector } from "../redux/slices/appState/appStateSelector";

export const usePermissions = () => {
  const {
    // roles,
    // permissionPages,
    permissions,
  } = useSelector(userRolesPermissionsSelector);

  //   check where it is required, if not then remove
  //   const isAdmin = roles.includes("Admin");
  //   const isSuperAdmin = roles.includes("Super Admin");
  //   const isCoachAdmin = roles.includes("Coach Admin");
  //   const isCoach = roles.includes("Coach");
  //   const isBilling = roles.includes("Billing");
  //   const isDeliveryCoach = roles.includes("Delivery Coach");
  //   const isDeliverySupport = roles.includes("Delivery Support");
  //   const isCorporateAdmin = roles.includes("Corporate Admin");
  //   const isProjectManager = roles.includes("Project Manager");

  /**
   * For checking access to page-level permissions via PAGE_PERMISSIONS_MAPPINGS map
   */
  const hasPagePermission = (destinationPath: string): boolean => {
    const requiredPageKey = PAGE_PERMISSIONS_MAPPINGS[destinationPath];
    return permissions.includes(requiredPageKey) || isEmpty(requiredPageKey);
    // for left menu temporary added isEmpty condition here, remove later all pages keys are available
  };

  /**
   * For checking feature/module-specific permission strings directly
   */
  const hasModulePermission = (permissionKey: string): boolean => {
    return permissions.includes(permissionKey);
  };

  return {
    hasPagePermission,
    hasModulePermission,
  };
};
